// extracted by mini-css-extract-plugin
export var cardContainer = "SupportDownloadCard-module--cardContainer---IhhS";
export var lineDivisor = "SupportDownloadCard-module--lineDivisor--7d0QI";
export var productLink = "SupportDownloadCard-module--productLink--yZ9Zb";